import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import { css, StyleSheet } from "aphrodite";
import { Column, Row } from "../grid";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	container: {
		display: "flex",
		[breakpoints.mobileOnly]: {
			flexDirection: "column-reverse",
		},
		[breakpoints.tabletAndUp]: {
			maxHeight: 370,
		},
	},
	imageContainer: {
		display: "flex",
		[breakpoints.tabletAndUp]: {
			flex: 10,
		},
	},
	image: {
		[breakpoints.tabletAndUp]: {
			minHeight: 256,
		},
	},
	titleContainer: {
		backgroundColor: colors.lightTeal,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontFamily: "priori-sans",
		color: colors.black,
		textAlign: "center",
		[breakpoints.tabletAndUp]: {
			flex: 4.5,
			paddingLeft: 40,
			paddingRight: 40,
			lineHeight: 0.82,
			fontSize: 55,
			fontWeight: 300,
		},
		[breakpoints.mobileOnly]: {
			paddingLeft: 20,
			paddingRight: 20,
			paddingTop: 16,
			paddingBottom: 18,
			fontSize: 35,
			lineHeight: 0.97,
		},
	},
});

export default class Banner extends PureComponent {
	static propTypes = {
		title: PropTypes.string.isRequired,
		images: PropTypes.object.isRequired,
	};

	render() {
		return (
			<Row>
				<Column smallFullScreen={true}>
					<div className={css(styles.container)}>
						<div className={css(styles.titleContainer)}>{this.props.title}</div>
						<div className={css(styles.imageContainer)}>
							<img
								className={css(styles.image)}
								src={this.props.images.url3x}
								alt="Class Header"
								height="100%"
								width="100%"
							/>
						</div>
					</div>
				</Column>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Banner.js